import React from "react";
import PropTypes from "prop-types";
import { CompletedSubtaskItemContainer } from "./CompletedSubtaskItemContainer.jsx";

const CompletedSubtaskList = ({ subtaskIds, isTaskCompleted }) => (
  <div className="task_list subtask_list">
    <div className="tasks sortable_enabled editable">
      <ul className="SortableList SubtaskGroup">
        {subtaskIds.map((subtaskId, index) => (
          <li
            className="SortableListItem"
            key={`subtask-${subtaskId}`}
          >
            <CompletedSubtaskItemContainer
              id={subtaskId}
              key={`subtask-${subtaskId}-${index}`}
              isTaskCompleted={isTaskCompleted}
            />
          </li>
        ))}
      </ul>
    </div>
  </div>
);

CompletedSubtaskList.propTypes = {
  subtaskIds: PropTypes.arrayOf(PropTypes.number),
  isTaskCompleted: PropTypes.bool,
};

CompletedSubtaskList.defaultProps = {
  subtaskIds: [],
  isTaskCompleted: false,
};

CompletedSubtaskList.displayName = "CompletedSubtaskList";

export default CompletedSubtaskList;
